module.exports = __webpack_public_path__ + "img/icon_gongneng6.3a412417.svg";